import React, { Component, PropTypes} from 'react';
import config from '../../../config';
import moment from 'moment';
import Modal from '../../commons/Modal/Modal';
import { TextInputField, DateField,
    TimePickerField, TextAreaField,
    BootstrapSelect } from '../../commons/Inputs';

let $ = window.jQuery;
let Handlebars = window.Handlebars;
let Bloodhound = window.Bloodhound;

export default class AppointmentModal extends Component {
    static propTypes = {
        dentists: PropTypes.array.isRequired,
        branches: PropTypes.array.isRequired,
        procedures: PropTypes.array.isRequired,
        session: PropTypes.object.isRequired,
        appointments: PropTypes.object.isRequired,
        postAppointmentApi: PropTypes.func.isRequired,
        putAppointmentApi: PropTypes.func.isRequired,
        showNotification: PropTypes.func.isRequired
    };

    state = {
        isSaving: false,
        formClear: false,
        isNewPatient: false,
        newOrExistingSelectionPage: true,
        patients: [],
        dentists: [],
        procedures: [],
        branches: [],
        appointmentId: 0,
        patientId: 0,
        patientName: '',
        patientLast: '',
        appointmentDate: '',
        startTime: '',
        endTime: '',
        procedure: 0,
        emailAddress: '',
        mobileNumber: '',
        branch: 0,
        dentist: 0,
        dentalChair: 1,
        remarks: '',
        updateTime: true
    };

    // Save the appointment
    handlePositiveModalClick = () => {
        this.setState({
            isSaving: true
        });

        let valid = true;
        if (this.state.patientName === '') {
            $('#remote').addClass('has-error');
            valid = false;
        }

        if (this.state.patientLast === '') {
            $('#remote2').addClass('has-error');
            valid = false;
        }

        if (! valid) {
            this.props.showNotification('error', 'Please check the required fields');

            this.setState({
                isSaving: false
            });

            return false;
        }

        let data = {
            patient_id: this.state.patientId,
            first_name: this.state.patientName,
            last_name: this.state.patientLast,
            practitioner_id: this.state.dentist,
            facility_id: this.state.branch,
            procedure_id: this.state.procedure,
            dental_chair_number: this.state.dentalChair,
            appointment_date: moment(this.state.appointmentDate, 'MMMM DD, YYYY').format(),
            start_time: moment(this.state.startTime, 'hh:mm A').format('HH:mm:ss'),
            end_time: moment(this.state.endTime, 'hh:mm A').format('HH:mm:ss'),
            remarks: this.state.remarks,
            phone: this.state.mobileNumber,
            email: this.state.emailAddress,
            is_new: this.state.isNewPatient
        };

        // Additional check for new patient
        if (this.state.isNewPatient) {
            data['patient_id'] = 0;
        }

        if (! this.state.appointmentId) {
            this.saveAppointment(data);
        } else {
            this.updateAppointment(data);
        }
    };

    updateAppointment = (data) => {
        this.props.putAppointmentApi(data, this.state.appointmentId);
    };

    saveAppointment = (data) => {
        this.props.postAppointmentApi(data);
    };

    handleCloseModal = () => {
        let data = {
            newOrExistingSelectionPage: true,
            isNewPatient: false,
            appointmentId: 0,
            patientId: 0,
            patientName: '',
            patientLast: '',
            appointmentDate: '',
            startTime: '',
            endTime: '',
            procedure: 0,
            mobileNumber: '',
            emailAddress: '',
            remarks: '',
            dentalChair: 1
        };

        this.setDefaultDentist();
        this.setDefaultBranch();

        this.setState(data);
    };

    setDefaultDentist = () => {
        let dentists = this.props.dentists;

        if (! dentists) {
            return;
        }

        if (! this.props.session) {
            return;
        }

        let user = this.props.session.get('user').toJSON();

        // Default selected
        let dentistId = 0;
        if (user.user_info.user_type_id === 1 || user.user_info.user_type_id === 9 || user.user_info.user_type_id === 10) {
            dentistId = user.role_info.id;
        }

        if (dentists.length < 3) {
            dentistId = dentists[1].value;
        }

        this.setState({
            dentist: dentistId
        })
    };

    setDefaultBranch = () => {
        let branches = this.props.branches;

        if (! branches) {
            return;
        }

        let user = this.props.session.get('user').toJSON();

        // Default selected
        let branchId = user.user_info.facility_id;

        if (branches.length < 3) {
            branchId = branches[1].value;
        }

        this.setState({
            branch: branchId
        })
    };

    getDentists = (data) => {
        $('#practitioner_id').selectpicker('refresh');

        let propsDentists = [...data];
        propsDentists.splice(0, 2);

        return [
            {
                value: 0,
                label: 'Select Dentist...'
            },
            ...propsDentists
        ];
    };

    getProcedures = (data) => {
        $('#procedure_id').selectpicker('refresh');

        let procedureProp = [...data];
        procedureProp.splice(0, 1);

        return [
            {
                value: 0,
                label: 'Select Procedure...'
            },
            ...procedureProp
        ];
    };

    getBranches = (data) => {
        $('#facility_id').selectpicker('refresh');

        let branchesProp = [...data];
        branchesProp.splice(0, 2);
        
        return [
            {
                value: 0,
                label: 'Select Clinic Branch...'
            },
            ...branchesProp
        ];
    };

    getTypeAheadData = (data) => {
        this.setState({
            patientName: data.first_name,
            patientLast: data.last_name,
            patientId: data.id,
            mobileNumber: data.phone ? data.phone : '',
            emailAddress: data.email ? data.email : ''
        });
    };

    clearTypeAheadData = () => {
        this.setState({
            patientName: '',
            patientLast:'',
            patientId: 0,
            mobileNumber: '',
            emailAddress: ''
        });
    };

    typeAheadForLastName = () => {
        $('#remote2 #patient_id2').typeahead(null, {
            name: 'patients',
            display: 'last_name',
            source: this.state.patients,
            templates: {
                empty: Handlebars.compile([
                    '<div class="empty-message" style="font-size: 13px; color: #000; padding: 10px;">',
                    'Unable to find any patient that match the current search query',
                    '</div>'
                ].join('\n')),
                suggestion: Handlebars.compile([
                    '<div class="media">',
                    '<div class="pull-left">',
                    '<div class="media-object">',
                    '<img src="'+config.staticFiles+'{{image}}" class="img-circle" width="50" height="50" style="border: 1px solid #ddd" onerror="this.onerror=null;this.src=\'/images/generic_profile_pic.png\'"/>',
                    '</div>',
                    '</div>',
                    '<div class="media-body">',
                    '<h4 class="media-heading">{{name}}</h4>',
                    '<p>{{id}}</p>',
                    '</div>',
                    '</div>'
                ].join(''))
            }
        }).on('typeahead:selected', (obj, datum) => {
            this.getTypeAheadData(datum);
        }).on('typeahead:active', (e) => {
            $(e.target).siblings('.form-control-focus').remove();
            $(e.target).siblings('.help-block').remove();
            $(e.target).parent().append('<div class="form-control-focus"></div><span class="help-block">Type something to start searching for patient...</span>');
        });
    };

    typeAheadForFirstName = () => {
        $('#remote #patient_id').typeahead(null, {
            name: 'patients',
            display: 'first_name',
            source: this.state.patients,
            templates: {
                empty: Handlebars.compile([
                    '<div class="empty-message" style="font-size: 13px; color: #000; padding: 10px;">',
                    'Unable to find any patient that match the current search query',
                    '</div>'
                ].join('\n')),
                suggestion: Handlebars.compile([
                    '<div class="media">',
                    '<div class="pull-left">',
                    '<div class="media-object">',
                    '<img src="'+config.staticFiles+'{{image}}" class="img-circle" style="border: 1px solid #ddd" width="50" height="50" onerror="this.onerror=null;this.src=\'/images/generic_profile_pic.png\'"/>',
                    '</div>',
                    '</div>',
                    '<div class="media-body">',
                    '<h4 class="media-heading">{{name}}</h4>',
                    '<p>{{id}}</p>',
                    '</div>',
                    '</div>'
                ].join(''))
            }
        }).on('typeahead:selected', (obj, datum) => {
            this.getTypeAheadData(datum);
        }).on('typeahead:autocompleted', (obj, datum) => {
            this.getTypeAheadData(datum);
        }).on('typeahead:change', (obj, datum) => {
            console.log(datum);
        }).on('typeahead:active', (e) => {
            $(e.target).siblings('.form-control-focus').remove();
            $(e.target).siblings('.help-block').remove();
            $(e.target).parent().append('<div class="form-control-focus"></div><span class="help-block">Type something to start searching for patient...</span>');
        });
    };

    handleNewOrExistingPatient = (e) => {
        if (e.target.value === 'new') {
            this.setState({
                isNewPatient: true,
                patientId: 0
            });

            $('#remote #patient_id').typeahead('destroy');
            $('#remote2 #patient_id2').typeahead('destroy');
        } else {
            this.setState({
                isNewPatient: false
            });

            this.typeAheadForFirstName();
            this.typeAheadForLastName();
        }
    };

    populateForm = (appointment) => {
        this.setState({
            newOrExistingSelectionPage: false,
            appointmentId: appointment.appointmentId,
            patientId: appointment.patientId,
            patientName: appointment.patientName,
            patientLast: appointment.patientLast,
            appointmentDate: appointment.appointmentDate,
            startTime: appointment.startTime,
            endTime: appointment.endTime,
            procedure: appointment.procedure,
            emailAddress: appointment.emailAddress ? appointment.emailAddress : '',
            mobileNumber: appointment.mobileNumber ? appointment.mobileNumber : '',
            branch: appointment.branch,
            dentist: appointment.dentist,
            dentalChair: appointment.dentalChair,
            remarks: appointment.remarks
        }, () => {
            $('#procedure_id').selectpicker('val', this.state.procedure);
            $('#facility_id').selectpicker('val', this.state.branch);
            $('#practitioner_id').selectpicker('val', this.state.dentist);
            $('#dental_chair').selectpicker('val', this.state.dentalChair);

            $('#start_time').val(this.state.startTime);
            $('#end_time').val(this.state.endTime);
        });
    };

    componentWillMount() {
        // Typeahead
        let patients = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: config.apiUrl + 'fuzzy-patient-search?q=%QUERY',
                wildcard: '%QUERY'
            }
        });

        this.setState({
            patients
        });
    }

    componentDidMount() {
        $('#newAppointmentModal').on('show', () => {
            this.setState({
                updateTime: moment().unix()
            });
        });

        this.typeAheadForFirstName();
        this.typeAheadForLastName();

        this.setDefaultBranch();
        this.setDefaultDentist();
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            isSaving: nextProps.appointments.get('isSaving')
        });

        if (nextProps.appointments.get('isSaved')) {
            $('#newAppointmentModal').modal('hide');
            this.handleCloseModal();

            this.props.showNotification('success', 'Appointment saved successfully');
        }

        if (nextProps.appointments.get('isFailed')) {
            this.props.showNotification('error', 'An error occured when saving the appointment');
        }

        if (nextProps.appointments.get('isViewing')) {
            let appointment = nextProps.appointments.get('activeAppointment').toJS();

            this.populateForm(appointment);
        }

        if (nextProps.dateClicked !== this.props.dateClicked) {
            let appointmentDate = moment(nextProps.dateClicked).format('MMMM DD, YYYY');

            this.setState({
                appointmentDate
            });
        }
    }

    render() {
        const { dentists, branches, procedures, appointments } = this.props;
        let dentistsOptions = this.getDentists(dentists);
        let branchesOptions = this.getBranches(branches);
        let proceduresOptions = this.getProcedures(procedures);

        let chairs = [
            {
                value: 0,
                label: 'Select Dental Chair...'
            },
            {
                value: 1,
                label: 'Chair 1'
            },
            {
                value: 2,
                label: 'Chair 2'
            },
            {
                value: 3,
                label: 'Chair 3'
            },
            {
                value: 4,
                label: 'Chair 4'
            },
            {
                value: 5,
                label: 'Chair 5'
            },
            {
                value: 6,
                label: 'Chair 6'
            }
        ];

        const isViewing = appointments.get('isViewing');

        // destroy typeahead on viewing/updating
        if (isViewing) {
            $('#remote #patient_id').typeahead('destroy');
            $('#remote2 #patient_id2').typeahead('destroy');
        }

        let content = () => {
            return (
                <div className="row">
                    <div id="alert-modal-container" style={{ paddingRight: '20px', paddingLeft: '20px' }}></div>

                    <div className="col-md-12" style={{ display: isViewing ? 'none' : 'block' }}>
                        <div className="md-radio" style={{ float: 'left' }}>
                            <input type="radio" name="existing" id="existing" className="md-radiobtn"
                                   checked={!this.state.isNewPatient}
                                   onChange={this.handleNewOrExistingPatient}
                                   value="existing" />

                            <label htmlFor="existing">
                                <span/>
                                <span className="check"/>
                                <span className="box"/> Existing Patient </label>
                        </div>

                        <div className="md-radio" style={{ float: 'left', marginLeft: '20px' }}>
                            <input type="radio" name="existing" id="new" className="md-radiobtn"
                                   checked={this.state.isNewPatient}
                                   onChange={this.handleNewOrExistingPatient}
                                   value="new" />

                            <label htmlFor="new">
                                <span/>
                                <span className="check"/>
                                <span className="box"/> New Patient </label>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="col-md-6">
                            <div className="form-group form-md-line-input" id="remote">
                                <input type="text" className="form-control"
                                       value={this.state.patientName}
                                       onChange={(e) => this.setState({patientName: e.target.value})}
                                       readOnly={isViewing}
                                       id="patient_id" placeholder="First Name *" />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group form-md-line-input" id="remote2">
                                <input type="text" className="form-control"
                                       value={this.state.patientLast}
                                       onChange={(e) => this.setState({patientLast: e.target.value})}
                                       readOnly={isViewing}
                                       id="patient_id2" placeholder="Last Name *" />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <TextInputField id="mobile_number" label="Mobile Number"
                                            help=""
                                            mobileMask={false}
                                            onChange={(e) => {this.setState({mobileNumber: e.target.value})}}
                                            val={this.state.mobileNumber} />
                        </div>

                        <div className="col-md-6">
                            <TextInputField id="email" label="Email Address"
                                            help=""
                                            onChange={(e) => {this.setState({emailAddress: e.target.value})}}
                                            val={this.state.emailAddress} />
                        </div>

                        <div className="col-md-4">
                            <DateField id="appointment_date" label="Appointment Date *"
                                       help="Select date for the appointment..."
                                       onChange={(e) => {this.setState({appointmentDate: e.target.value});}}
                                       startDate={'0'}
                                       val={this.state.appointmentDate} />
                        </div>

                        <div className="col-md-4">
                            <TimePickerField id="start_time" label="Start Time *"
                                             help="Select start time for appointment..."
                                             onChange={(e) => {this.setState({startTime: e})}}
                                             val={this.state.startTime}
                                             adjustMinutes={0}
                                             updateTime={this.state.updateTime} />
                        </div>

                        <div className="col-md-4">
                            <TimePickerField id="end_time" label="End Time *"
                                             help="Select end time for appointment..."
                                             onChange={(e) => {this.setState({endTime: e})}}
                                             val={this.state.endTime}
                                             adjustMinutes={15}
                                             updateTime={this.state.updateTime} />
                        </div>

                        <div className="col-md-3">
                            <BootstrapSelect id="procedure_id" label="Procedure"
                                             help="Select procedure..."
                                             val={this.state.procedure}
                                             onChange={(e) => {this.setState({procedure: e.target.value})}}
                                             options={proceduresOptions} />
                        </div>

                        <div className="col-md-3">
                            <BootstrapSelect id="facility_id" label="Clinic Branch *"
                                             help="Select clinic branch..."
                                             val={this.state.branch}
                                             onChange={(e) => {this.setState({branch: e.target.value})}}
                                             options={branchesOptions} />
                        </div>

                        <div className="col-md-3">
                            <BootstrapSelect id="practitioner_id" label="Dentist *"
                                             help="Select dentist..."
                                             val={this.state.dentist}
                                             onChange={(e) => {this.setState({dentist: e.target.value})}}
                                             options={dentistsOptions} />
                        </div>

                        <div className="col-md-3">
                            <BootstrapSelect id="dental_chair" label="Dental Chair *"
                                             help="Select dental chair number..."
                                             val={this.state.dentalChair}
                                             onChange={(e) => {this.setState({dentalChair: e.target.value})}}
                                             options={chairs} />
                        </div>

                        <div className="col-md-12">
                            <TextAreaField id="remarks" label="Remarks"
                                           help="Type a remarks"
                                           onChange={(e) => {this.setState({remarks: e.target.value})}}
                                           val={this.state.remarks} />
                        </div>
                    </div>
                </div>
            )
        };

        return (
            <Modal id="newAppointmentModal" header={isViewing ? 'Viewing appointment' : 'Create New Appointment'}
                   positiveButton="Save Record"
                   negativeButton="Cancel"
                   width="900"
                   onPositiveClickEvent={this.handlePositiveModalClick}
                   onNegativeClickEvent={this.handleCloseModal}
                   isSaving={this.state.isSaving}>

                {content()}
            </Modal>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/home/AppointmentModal.js
 **/